import React from 'react';
import Icon from '../../../components/AppIcon';

const EditingIndicator = ({ editableCount, totalCount }) => {
  if (editableCount === 0) return null;

  return (
    <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 mb-6">
      <div className="flex items-start space-x-3">
        <div className="flex items-center justify-center w-8 h-8 bg-accent/20 rounded-lg flex-shrink-0">
          <Icon name="Edit3" size={16} className="text-accent" />
        </div>
        
        <div className="flex-1">
          <h3 className="font-heading font-medium text-foreground mb-1">
            Editing Window Active
          </h3>
          <p className="text-sm text-muted-foreground mb-3">
            You can edit entries from the past 72 hours. Changes will update your statistics immediately.
          </p>
          
          <div className="flex items-center space-x-4 text-sm">
            <div className="flex items-center space-x-1">
              <div className="w-2 h-2 bg-accent rounded-full"></div>
              <span className="text-foreground">
                {editableCount} editable {editableCount === 1 ? 'entry' : 'entries'}
              </span>
            </div>
            
            <div className="flex items-center space-x-1">
              <div className="w-2 h-2 bg-muted-foreground rounded-full"></div>
              <span className="text-muted-foreground">
                {totalCount - editableCount} read-only {totalCount - editableCount === 1 ? 'entry' : 'entries'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditingIndicator;